import React, { useState, useEffect, useContext, useRef } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { getClients } from "src/store/client";
import { getUsers } from "src/store/user";
import { getProjects} from "src/store/project";
import SearchForm from 'src/components/project/SearchForm';
import ProjectTable from 'src/components/project/ProjectTable';
import Header from 'src/components/common/Header';
import Menu from 'src/components/common/Menu';
import { MenuContext } from 'src/context/MenuContext';
import { getMcode }from "src/store/mcode";
import ScrollTop from 'src/components/common/ScrollTop';
import CustomLoader from 'src/components/common/CustomLoader';

function ProjectList() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const clientList = useSelector((state) => state.client.data);
  const userList = useSelector((state) => state.user.data)
  const projectList = useSelector((state) => state.project.data)
  const projectcategory = useSelector((state) => state.mcode.data.projectcategory)
  const [isPopupVisible, setPopupVisible] = useState(false);
  const [loading, setLoading] = useState(true);


  useEffect(() => {
      setLoading(true);

      Promise.all([
        dispatch(getClients()),
        dispatch(getUsers()),
        dispatch(getProjects()),
        dispatch(getMcode({ section_cd: 'projectcategory' })),
      ]).then(() => {
        setLoading(false);
      }).catch((error) => {
        console.error("Error loading data:", error);
        setLoading(false);
      });
  }, [dispatch]);

  const [params, setParams] = useState({
    t_client_id: '',
    name_abbreviation: '',
    category_cd: '',
    manager_id: '',
  });
  const paramsRef = useRef(params);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setParams({ ...params, [name]: value });
  };

  const projectInput = (e) => {
    navigate('/projectInput');
  };

  const handleSearch = (e) => {
    if (e) {
      e.preventDefault();
    }
    dispatch(getProjects({ params : paramsRef.current }));
  };

  const handleClear = () => {
    const clearedParams = {
      t_client_id: '',
      name_abbreviation: '',
      category_cd: '',
      manager_id: '',
    };
    setParams(clearedParams);
    paramsRef.current = clearedParams;  // Update ref immediately
    handleSearch();
  };

  useEffect(() => {
    paramsRef.current = params;
  }, [params]); 

  const handlePopupOpen = () => {
    setPopupVisible(true); // Show the pop-up
  };

  const handlePopupClose = () => {
    setPopupVisible(false); // Hide the pop-up
  };

    // Destructuring correctly from menuContext
    const { visibleMenu} = useContext(MenuContext);

  return (
    <>
    {visibleMenu && <Menu />}
    <div className={visibleMenu ? 'menu-open' : 'menu-closed'}>
      <Header sx={{ mb: 500 }} />
      <div className="wrapper">
      {loading ? 
          // <div className="loader-wrapper">
          // <div className="loader-container">
            <CustomLoader />
        //   </div>
        // </div>
         : 
      <>
          <section className="container-fluid contents-top">
              <div className="text-center">
                  <h1>Project List　<button type="button" className="btn btn-default notice-popup-open" onClick={handlePopupOpen}><span className="glyphicon glyphicon-question-sign" aria-hidden="true"></span></button></h1>
                  <SearchForm
                      params={params}
                      handleChange={handleChange}
                      projectInput={projectInput}
                      handleSearch={handleSearch}
                      handleClear={handleClear}
                      clientList={clientList}
                      userList={userList}
                      projectcategory={projectcategory} />
                      
              </div>
          </section>
        
            <ProjectTable projectList={projectList} userList={userList}/>
          </>
          }
      </div>
        <Popup isVisible={isPopupVisible} onClose={handlePopupClose} />
      </div>
      <ScrollTop/>
      </>
  );
}

const Popup = ({ isVisible, onClose }) => {
  if (!isVisible) return null;

  return (
    <div className="popup-area">
      <div className="popup-scroll">
        <div className="text-center" style={{ color: 'yellow' }}> 
          <p>
            ※*After selecting and entering each item, press the Search button to search for registered projects,<br />
            「Press the "+" button to display the project registration screen and register a new project.<br />
            When registering a new project, be sure to fill in the items marked with "※".<br />
            If you do not enter a project name (abbreviation), the project will be registered with the name you enter.<br />
            Use the project name (abbreviation) when registering a task.
          </p>
        </div>
        {/* Close Button */}
        <div
          className="popup-close notice-popup-close"
          onClick={onClose} // Close the popup on click
          role="button"
          style={{ cursor: 'pointer' }}
        >
          <span className="glyphicon glyphicon-remove" aria-hidden="true"></span>
        </div>
      </div>
    </div>
  );
};

export default ProjectList;
